export class ConsumerModel {
    id: string | undefined;
    name: string | undefined;
    email: string | undefined;
    description: string | undefined;
    uniqueKey: string | undefined;
}